import React, { FC } from 'react';

import TextareaAutosize from 'react-textarea-autosize';
import { TextareaAutosizeProps } from 'react-textarea-autosize/dist/declarations/src';

const TextArea: FC<TextareaAutosizeProps> = (props) => {
  return <TextareaAutosize {...props} />;
};

export default TextArea;
